import React, { Component } from "react";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import { ACTIVITY_TYPE } from "../../../../common/Constants";

class TabAnalisaFJB extends Component {
  setValue = (name, value) => {
    const { onSetSpesificData } = this.props;
    onSetSpesificData("dataAnalisa", name, value);
  };
  render() {
    const { formData,activityType, errors, isSO, isDirectSales } = this.props;
    const dataAnalisa = formData?.dataAnalisa || {};
    const isReadOnly = activityType === ACTIVITY_TYPE.VIEW || isSO || isDirectSales;
    const isMandatory = !isSO && !isDirectSales

    
    return (
      <React.Fragment>
        <div className="grid grid-2x gap-20px grid-mobile-none">
          <div id="grid-1">
            <SimpleTextArea
              id="input_text_rekomendasi"
              name="rekomendasiSa"
              label="Rekomendasi SA"
              mandatory={isMandatory}
              errorMessage={errors?.dataAnalisa?.rekomendasiSa}
              readOnly={isReadOnly}
              value={dataAnalisa.rekomendasiSa}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
          </div>
          <div id="grid-2">
            <SimpleTextArea
              id="input_text_keluhan"
              name="keluhanKonsumen"
              label="Keluhan Konsumen"
              mandatory={isMandatory}
              errorMessage={errors?.dataAnalisa?.keluhanKonsumen}
              readOnly={isReadOnly}
              value={dataAnalisa.keluhanKonsumen}
              onChange={({ target }) =>
                this.setValue(target.name, target.value)
              }
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TabAnalisaFJB;
